import React, { useState, useEffect } from 'react';

import { ContentBox } from "../ContentBox"
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleInput, SingleSelect } from '../../Res/BaseInput';
import { EnableBadge, DisableBadge, AddButton, CancelButton, SearchButton, SingleLink } from '../../Res/BaseButton';
import { ReqResumeList } from '../../../../item/ItemResume';
import { api_getResumeList, api_getSkill } from '../../../../api/apiResume';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { Pagination } from '../../Res/Pagination';
import { uuid } from '../../../../item/ItemTools';
import { setResume2Token, getval2Token, setVal2Token } from '../../../Login/Auth';

import { AutoSelect } from '../../Res/AutoSelect';

export function ContractorResumeList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")

    const [resumeList, setResumeList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [disableCount, setDisableCount] = useState(0)
    const [enableCount, setEnableCount] = useState(0)

    const [mReqResumeList, setReqResumeList] = useState({})

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqResumeList = new ReqResumeList({ start, limit })
            if(url === ""){
                setReqResumeList(mReqResumeList)
                toSearch({ items: mReqResumeList, page: url.page })
            }else{
                mReqResumeList.fromJson(url)
                toSearch({ items: mReqResumeList, page: url.page })
            }
        }
    }, [id])

    // useEffect(()=>{
    //     if(Object.keys(mReqResumeList).length !== 0){
    //         toSearch({items: mReqResumeList})
    //     }
    // },[mReqResumeList])

    function toSearch({ items, page = 1 }) {
        //console.log("toSearch")
        var start = (page - 1) * limit;
        setPage(page)
        var mReqResumeList = new ReqResumeList({ start, limit, isPublic: false })
        console.log(mReqResumeList)
        if (items !== undefined)
            mReqResumeList.fromJson(items)
        mReqResumeList.page = page
        setVal2Token("url", mReqResumeList, id)
        console.log(mReqResumeList)
        getResumeList(mReqResumeList)
    }

    function toSearchFromPage({page = 1}){
        var start = (page - 1) * limit;
        setPage(page)
        var url = getval2Token("url", id)
        var mReqRecruitmentContractorStatusList = new ReqResumeList({ start, limit, isPublic: false })
        mReqRecruitmentContractorStatusList.fromJson(url)
        console.log(mReqRecruitmentContractorStatusList)
        mReqRecruitmentContractorStatusList.page = page
        setVal2Token("url", mReqRecruitmentContractorStatusList, id)
        getResumeList(mReqRecruitmentContractorStatusList)
    }

    function getResumeList(mReqResumeList) {
        setIsLoading(true)
        console.log("getResumeList")
        console.log(mReqResumeList)
        api_getResumeList({
            mReqResumeList,
            success: (obj) => {
                console.log(obj)
                setResumeList(obj.list)
                setCount(obj.count)
                setDisableCount(obj.disableCount)
                setEnableCount(obj.enableCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/ContractorResumeAdd");
    }


    var baseTitle = "帳號列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"上工"} count={enableCount} />
                    <DisableBadge text={"下工"} count={disableCount} />
                    <AddButton name={"新增"} action={toAdd} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                </div>
            </div>
            <div className="row m-b-sm">
            </div>
            <ResumeListBox resumeList={resumeList} srl={setResumeList} count={count} page={page} sp={toSearchFromPage} />
        </>
    return (
        <>
            <ResumeListSearch action={toSearch} />
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

function ResumeListSearch({ action }) {
    const [name, setName] = useState("")
    const [address, setAddress] = useState("")
    const [jobStatus, setJobStatus] = useState("3")
    const [owner, setOwner] = useState("")
    const [office, setOffice] = useState("")
    const [skill, setSkill] = useState("")

    const [skillList, setSkillList] = useState([])


    useEffect(() => {
        getSkillList()
    }, [])

    function getSkillList() {
        api_getSkill({
            success: (result) => {
                setSkillList(result.list)
            },
            failure: (err) => {

            }
        })
    }

    function toClear() {
        setName("")
        setAddress("")
        setJobStatus("3")
        setSkill("")
    }

    function toSearch() {
        var mReqResumeList = new ReqResumeList({
            name,
            address,
            jobStatus,
            skill
        })
        action({ items: mReqResumeList })
    }


    var content =
        <>
            <div className="row">
                <SingleInput title={"以姓名搜尋"} val={name} action={setName} size={4} />
                <SingleInput title={"以通訊地址搜尋"} val={address} action={setAddress} size={4} />
                <SingleSelect title={"上工狀態"}
                    val={"3"}
                    attr={[
                        /*{ "val": "1", "name": "全部" },
                        { "val": "2", "name": "上工" },*/
                        { "val": "3", "name": "下工" }
                    ]}
                    action={setJobStatus}
                    size={4}
                />
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <SingleInput title={"以專員搜尋"} val={owner} action={setOwner} size={4} disabled={true} />
                <SingleInput title={"以廠商名稱搜尋"} val={office} action={setOffice} size={4} disabled={true} />
                <AutoSelect
                    title={"以專長搜尋"}
                    attr={skillList}
                    val={skill}
                    v={'skillId'}
                    n={'skillName'}
                    action={setSkill}
                    size={4}
                />
            </div>


            <div className="row m-t-sm m-t-sm">
                <div className="col-sm-4 col-sm-offset-5">
                    <CancelButton name={"清除"} action={toClear} />
                    <SearchButton action={toSearch} />
                </div>
            </div>

        </>
    return (
        <ContentBox hasTitle={false} content={content} hasDrawer={false} />
    )
}

function ResumeListBox({ resumeList, srl, count, page, sp }) {
    const [mResumeList, setResumeList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (resumeList !== undefined && mResumeList !== resumeList) {
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + resumeList.length)
            setResumeList(setTableList(resumeList))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [resumeList, count])

    function setTableList(resumeList) {
        var list = []
        for (var i = 0; i < limit; i++) {
            if (resumeList[i] !== undefined) {
                list.push(<ResumeBox key={resumeList[i].resumeId} resume={resumeList[i]} />)
            } else {
                list.push(<ResumeBox key={"resumeId" + i} />)
            }
        }
        return list
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (mResumeList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-3">姓名</th>
                                    <th className="text-center sorting col-sm-1">年齡</th>
                                    <th className="text-center sorting col-sm-1">性別</th>
                                    <th className="text-center sorting col-sm-3">離職日</th>
                                    <th className="text-center sorting col-sm-2">狀態</th>
                                    <th className="text-center sorting col-sm-2">提交</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    mResumeList.map((resume) => (
                                        resume
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function ResumeBox({ resume }) {
    const [mResume, setResume] = useState({})
    const [mName, setName] = useState("")
    const [mAge, setAge] = useState("")
    const [isPublic, setIsPublic] = useState("")
    const [mTokenId, setTokenId] = useState("")

    useEffect(() => {
        if (resume !== undefined && resume !== mResume) {
            setResume(resume)
            var tokenId = uuid(128, 64)
            setTokenId(tokenId)

            if (resume.name !== undefined && resume.name !== null) {
                setName(resume.name)
            } else {
                setName('N/A')
            }

            const startDate = moment(resume.birthday);
            const endDate = moment(new Date());
            const age = endDate.diff(startDate, 'years');
            setAge(age)
            setIsPublic(resume.isPublic===1?"是":"")
        }
    }, [resume])

    // function toContractorResumeEdit() {
    //     setResume2Token(mResume.resumeId, mTokenId)
    //     //window.location.assign("/ContractorResumeDetail/" + mTokenId);
    //     window.open("/ContractorResumeDetail/" + mTokenId, "_blank");
    // }

    var sex = ""
    if (mResume.sex === "1") {
        sex = "男"
    } else if (mResume.sex === "2") {
        sex = "女"
    }

    var status = ""
    if (resume !== undefined) {
        status = <span className="text-danger">下工</span>
    }
    /*
    if (account.account_isDisable === 1) {
    status = <span className="text-danger">下工</span>
    } else {
    status = <span className="text-info">上工</span>
    }
    */

    return (
        <tr role="row">
            <td className="text-center"><SingleLink link={"ContractorResumeDetail"} name={mName} Key={"resumeId"} val={mResume.resumeId}></SingleLink>&nbsp;</td>
            <td className="text-center">{mAge}</td>
            <td className="text-center">{sex}</td>
            <td className="text-center">-</td>
            <td className="text-center"><span>{status}</span></td>
            <td className="text-center"><span>{isPublic}</span></td>
        </tr>
    )
    /**
     * 
      <tr>
        <td>
          <div className="feed-element">
            {avatar}
          </div>
        </td>
        <td style={{ verticalAlign: "middle" }}><div>{account.mobile}</div></td>
        <td style={{ verticalAlign: "middle" }}>{account.nickName}</td>
        <td style={{ verticalAlign: "middle" }}>{account.email}</td>
        <td style={{ verticalAlign: "middle" }}>{status}</td>
        <td style={{ verticalAlign: "middle" }}>{creatAt}</td>
        <td style={{ verticalAlign: "middle" }}>
          <a href="#A" className="btn btn-social-icon btn-linkedin" onClick={toCompanyList}><i className="fa fa-eye"></i></a>
        </td>
      </tr>
     */
}
